import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { AuthService, WindowService, backendUrl } from '@zvoove-market/shared';

export const authGuard = (): CanActivateFn => (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const windowService = inject(WindowService);
  const isLoggedIn = auth.$context().isLoggedIn;
  if (!isLoggedIn) {
    const windowObj = windowService.getInstance();
    windowObj.location.href =
      backendUrl() + '/bff/login?returnUrl=' + encodeURI(windowObj.location.pathname.replace(/^\/\//, '/') + windowObj.location.search);
  }

  return isLoggedIn;
};
